import {Component, OnInit} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {ServiceRequestService} from '../../../Services/service-request.service';
import {IButton} from '../../../../shared/card/card.component';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';

@Component({
  selector: 'app-dealer-service-request-overview',
  templateUrl: './service-request-overview.component.html',
  styleUrls: ['./service-request-overview.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class DealerServiceRequestOverviewComponent implements OnInit {
  public grid: Grid;
  public params;
  public baseUrl = environment.apiUrl;

  constructor(
    private serviceRequestService: ServiceRequestService,
    private router: Router,
    private translator: TranslateService,
    private auth: AuthenticationService,
  ) {}

  public specialButton: IButton[] = [];
  public specialButtonArray;

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.service.service_number',
          prop: 'service.serviceNumber',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.service.service_date',
          prop: 'service.createdAt',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.service.order_number',
          prop: 'service.order.orderNo',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.service.reference',
          prop: 'service.order.reference',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.service.subject',
          prop: 'service.serviceTitle',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.service.status',
          prop: 'service.status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => this.translator.instant(row.translationKey)
        },
        <TextColumn>{
          name: 'doctrine.service_request.current_step',
          prop: 'service.reply',
          type: TextColumn.type,
          sortable: false,
          translate: true,
          filterable: false,
          valueFormatter: (reply) => {
            const currentStepName = reply?.lastReplyItem?.solutionStep?.actionType?.name
            const stepNameStr = currentStepName ? `doctrine.solution.action_type.${currentStepName}` : `doctrine.solution.action_type.no_action`;
            return this.translator.instant(stepNameStr)
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              status: true,
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('dealer-system/service-request/' + row.service.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-bell-o fa-lg',
              onclick: row => this.router.navigateByUrl('dealer-system/service-request/' + row.service.id + '/show'),
              showCallback: row => row.service.reply && !row.service.reply.dealerIsRead,
              btnClass: 'ripple light '
            },
          ]
        }

      ],
      service: this.serviceRequestService,
      rememberURL: this.router.url,
      method: 'getServices',
      defaultSort: 'createdAt',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          calendarCustomWidth: 39,
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: false,
          hasStatus: false,
          hasNormalSearch: true,
          order: [
            {datepickerOrder: 2, normalSearchOrder: 1, statusOrder: 4}
          ],
          searchArrays: [
            {
              index: 3,
              value: new ServiceSearchItem(this.serviceRequestService, 'getServiceSubjects', {sortType: 'ASC', sortBy: null}, (res) => {

                const options = [];
                options.push({value: 'all', label: this.translator.instant('global.all')});
                for (const row of res) {
                  options.push({value: row.id, label: row.name});
                }
                return options;
              }),
              name: 'serviceSubject',
              label: 'doctrine.attributes.subject',
              width: 18,
            },
            {
              index: 3,
              value: new ServiceSearchItem(this.serviceRequestService, 'getServiceRequestStatuses', {sortType: 'ASC', sortBy: 'name'}, (res) => {

                const options = [];
                options.push({value: 'all', label: this.translator.instant('global.all')});
                for (const row of res) {
                  options.push({value: row.id, label: this.translator.instant(row.translationKey)});
                }
                return options;
              }),
              name: 'status',
              label: 'doctrine.user.status',
              width: 18,
            },
          ]
        }
      ],
    };

    this.specialButtonArray = [
      {name: this.translator.instant('admin.service.new'), btnIcon: 'feather icon-plus', customClass: 'btn-primary', method: 'addService'}
    ];
    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        btnIcon: items.btnIcon,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });

    });
  }

  calFunction(method: string) {
    this[method]();
  }

  setParams(event) {
    this.params = event;
  }

  addService() {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(
      () => this.router.navigate(['/dealer-system/service-request/add'], {replaceUrl: true}));
  }
}
